import React from 'react';

import { Choice, Group, RadioChoice, Toggle } from './OptionControls';

/**
 * The risk management section's options: the rating the list filters and
 * sorts on, the lowest rating it lists, and which blocks the page shows.
 */
const RiskManagementOptions = ({ options, readOnly, onChange }) => {
    const set = (changes) => onChange({ ...options, ...changes });
    const toggle = (key) => () => set({ [key]: !options[key] });

    return (
        <div className="tw-flex tw-flex-col tw-mt-3 tw-ps-4 tw-border-s-2 tw-border-charcoal-15">
            <Group title={$t('Rating basis for lists')}>
                <RadioChoice
                    name="mp-risk-basis"
                    label={$t('Rating basis for lists')}
                    value={options.basis}
                    choices={[
                        { value: 'post', label: $t('Post-treatment') },
                        { value: 'pre', label: $t('Pre-treatment') },
                    ]}
                    disabled={readOnly}
                    onChange={(basis) => set({ basis })}
                />
                <Choice
                    id="mp-risk-min-rating"
                    label={$t('Minimum rating to list')}
                    value={options.min_rating}
                    choices={[
                        { value: 'R', label: $t('Red only') },
                        { value: 'A', label: $t('Red and amber') },
                        { value: 'G', label: $t('All') },
                    ]}
                    disabled={readOnly}
                    onChange={(value) => set({ min_rating: value })}
                />
            </Group>
            <Group title={$t('Show')}>
                <Toggle
                    label={$t('Matrices')}
                    hint={$t('Pre and post treatment, count per cell')}
                    checked={!!options.show_matrices}
                    disabled={readOnly}
                    onChange={toggle('show_matrices')}
                />
                <Toggle
                    label={$t('Risks listed')}
                    hint={$t('Ordered by rating, then pre-treatment score')}
                    checked={!!options.show_list}
                    disabled={readOnly}
                    onChange={toggle('show_list')}
                />
                <Toggle
                    label={$t('Assessment changes flagged')}
                    hint={$t('Any risk whose pre or post treatment rating changed in the period')}
                    checked={!!options.show_changes}
                    disabled={readOnly}
                    onChange={toggle('show_changes')}
                />
                <Toggle
                    label={$t('Movement counts')}
                    hint={$t('New, closed, escalated, de-escalated')}
                    checked={!!options.show_movements}
                    disabled={readOnly}
                    onChange={toggle('show_movements')}
                />
                <Toggle label={$t('Show owner')} checked={!!options.show_owner} disabled={readOnly} onChange={toggle('show_owner')} />
            </Group>
        </div>
    );
};

export default RiskManagementOptions;
